import React from "react";
import { Snackbar, Alert, Slide, styled } from "@mui/material";

interface ToastProps {
  open: boolean;
  message: string;
  severity?: "success" | "info" | "warning" | "error";
  onClose: () => void;
}

const CenteredSnackbar = styled(Snackbar)(({ theme }) => ({
  "& .MuiSnackbarContent-root": {
    justifyContent: "center",
  },
}));

const Toast: React.FC<ToastProps> = ({ open, message, onClose, severity = "success" }) => {
  return (
    <CenteredSnackbar
      open={open}
      autoHideDuration={3000}
      onClose={onClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      TransitionComponent={(props) => <Slide {...props} direction="up" />}
    >
      <Alert onClose={onClose} severity={severity}>
        {message}
      </Alert>
    </CenteredSnackbar>
  );
};

export default Toast;
